export namespace TStorage {
  export const KEY_TOKEN = '__token__';
  export const KEY_USER_NAME = '__user_name__';
}
